import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'

const ModelDelete = ({ confirmOpen, handleCloseConfirm, isArabic, isDeletingSingle, handleConfirmDelete }) => {
    
    return (
        <>
            <Dialog
                open={confirmOpen}
                onClose={handleCloseConfirm}
                aria-labelledby="confirm-delete-title"
                aria-describedby="confirm-delete-description"
            >
                <DialogTitle id="confirm-delete-title">
                    {isArabic ? 'تأكيد الحذف' : 'Confirm delete'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-delete-description">
                        {isArabic
                            ? 'هل أنت متأكد أنك تريد حذف هذا العنصر؟ لا يمكن التراجع عن هذه العملية.'
                            : 'Are you sure you want to delete this item? This action cannot be undone.'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCloseConfirm}
                        disabled={isDeletingSingle}
                        variant="outlined"
                    >
                        {isArabic ? 'إلغاء' : 'Cancel'}
                    </Button>
                    <Button
                        onClick={handleConfirmDelete}
                        color="error"
                        variant="contained"
                        disabled={isDeletingSingle}
                    >
                        {isDeletingSingle
                            ? isArabic
                                ? 'جاري الحذف...'
                                : 'Deleting...'
                            : isArabic
                                ? 'تأكيد الحذف'
                                : 'Confirm'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ModelDelete